import React from 'react';
import clsx from 'clsx';

import './index.scss';
import logoRecruit from 'assets/logo-recruit-sp.svg';
import SpTitle from 'components/molecules/SpTitle';
import SpProgress from 'components/molecules/SpProgress';
import SpHeaderSideMenu from 'components/molecules/SpHeaderSideMenu';

const SpHeader = ({
  title,
  state,
  path,
}) => {
  const isThanksPage = path.includes('thanks') ? true : false;
  return (
    <div className='SpHeader'>
      <div className="sp-header {clsx('sp-cmnt-area', { checked })}">
        <div className="sp-header-wrapper">
          <div className="sp-header-area">
            <div className="logo-area">
              <a href="/sol/contents/client/" target="_blank" rel="noopener noreferrer">
                <img className="logo-recruit" src={logoRecruit} alt="logo-recruit" />
              </a>
            </div>
            <div className="menu-area">
              <div className="btn-area">
                <a href="/sol/op53/sd37/" target="_blank" className="btn">
                  <button className="" type="button">
                    お問い合わせ
                  </button>
                </a>
              </div>
              <div className="side-menu-area">
                <SpHeaderSideMenu />
              </div>
            </div>
          </div>
        </div>
        <div className="sp-header-horizon" />
      </div>
      <div className={clsx('sp-progress', { mB30: isThanksPage })}>
        <SpProgress path={path} />
      </div>
      <div className="sp-title">
        <SpTitle
          title={title}
          state={state}
          path={path}
        />
      </div>
    </div>
  );
};

export default SpHeader;
